<h2 class="t-medium m-b-40 h-sm">
  <strong>{{ heading }}</strong>
</h2>
<div class="mobile-options h-lg h-md">
  <p class="t-large m-b-16">
    <strong>{{ heading }}</strong>
  </p>
  <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
    <strong>{{ selected | titlecase }}</strong>
    <un-icon type="down"></un-icon>
  </a>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item>
        <div
          class="option"
          [ngClass]="{ active: selected === 'programs' }"
          (click)="selected = 'programs'"
        >
          <un-icon type="book" theme="outline"></un-icon>
          <span class="m-l-8" i18n="@@programs">Programs</span>
        </div>
      </li>
      <li nz-menu-item>
        <div
          class="option"
          [ngClass]="{ active: selected === 'institutes' }"
          (click)="selected = 'institutes'"
        >
          <un-icon type="bank" theme="outline"></un-icon>
          <span class="m-l-8" i18n="@@instiutes">Institutes</span>
        </div>
      </li>
      <li nz-menu-item>
        <div
          class="option"
          [ngClass]="{ active: selected === 'tours' }"
          (click)="selected = 'tours'"
        >
          <un-icon type="environment" theme="outline"></un-icon>
          <span class="m-l-8" i18n="@@tours">Tours</span>
        </div>
      </li>
    </ul>
  </nz-dropdown-menu>
</div>
@if (screen.size | async; as size) {
<div class="options c-soft t-medium h-sm m-b-24">
  <div
    class="option"
    [ngClass]="{ active: selected === 'programs' }"
    (click)="selected = 'programs'"
  >
    <un-icon type="book" theme="outline"></un-icon>
    @if (selected === 'programs' || size !== 'small') {
    <span i18n="@@programs">Programs</span>
    }
  </div>
  <div
    class="option"
    [ngClass]="{ active: selected === 'institutes' }"
    (click)="selected = 'institutes'"
  >
    <un-icon type="bank" theme="outline"></un-icon>
    @if (selected === 'institutes' || size !== 'small') {
    <span i18n="@@instiutes">Institutes</span>
    }
  </div>
  <div
    class="option"
    [ngClass]="{ active: selected === 'tours' }"
    (click)="selected = 'tours'"
  >
    <un-icon type="environment" theme="outline"></un-icon>
    @if (selected === 'tours' || size !== 'small') {
    <span i18n="@@tours">Tours</span>
    }
  </div>
  <div
    class="option"
    [ngClass]="{ active: selected === 'visa' }"
    (click)="selected = 'visa'"
  >
    <un-icon type="wallet" theme="outline"></un-icon>
    @if (selected === 'visa' || size !== 'small') {
    <span i18n="@@visa">Visa</span>
    }
  </div>
  <!-- <div
            class="option"
            [ngClass]="{ active: selected === 'visa' }"
            (click)="selected = 'visa'"
            >
            <un-icon type="idcard" theme="outline"></un-icon>
            <span *ngIf="size !== 'small' || selected === 'visa'" i18n="@@visa"
              >Visa</span
              >
            </div> -->
</div>
}
<div class="forms">
  @if (programsForm) {
  <div
    class="programs-form"
    [formGroup]="programsForm"
    [ngClass]="
      [selected === 'programs' ? 'active' : '', screen.size | async].join(' ')
    "
    (ngSubmit)="search()"
  >
    <un-input
      class="search"
      type="text"
      formControlName="search"
      suffixIcon="search"
      placeholder="Search for programs"
      i18n-placeholder="@@searchPrograms"
    ></un-input>
    <un-input
      class="level"
      type="select"
      formControlName="level"
      [options]="levels"
      placeholder="Program Level"
      i18n-placeholder="@@programLevel"
    ></un-input>
    <un-input
      class="country"
      type="auto-complete"
      formControlName="country"
      [autoComplete]="countryService.autoComplete"
      placeholder="Country"
      i18n-placeholder="@@country"
    ></un-input>
    <un-button class="btn" type="primary" i18n="@@search" (click)="search()"
      >Search</un-button
    >
  </div>
  } @if (institutesForm) {
  <div
    class="institutes-form"
    [formGroup]="institutesForm"
    [ngClass]="
      [selected === 'institutes' ? 'active' : '', screen.size | async].join(' ')
    "
    (ngSubmit)="search()"
  >
    <un-input
      class="country"
      type="auto-complete"
      formControlName="country"
      [autoComplete]="countryService.autoComplete"
      placeholder="Country"
      i18n-placeholder="@@country"
    ></un-input>
    <un-button class="btn" type="primary" i18n="@@search" (click)="search()"
      >Search</un-button
    >
  </div>
  } @if (toursForm) {
  <div
    class="tours-form"
    [formGroup]="toursForm"
    [ngClass]="
      [selected === 'tours' ? 'active' : '', screen.size | async].join(' ')
    "
    (ngSubmit)="search()"
  >
    <un-input
      class="country"
      type="auto-complete"
      formControlName="country"
      [autoComplete]="countryService.autoComplete"
      placeholder="Country"
      i18n-placeholder="@@country"
    ></un-input>
    <un-button class="btn" type="primary" i18n="@@search" (click)="search()"
      >Search</un-button
    >
  </div>
  } @if (visaForm) {
  <div
    class="visa-form"
    [formGroup]="visaForm"
    [ngClass]="
      [selected === 'visa' ? 'active' : '', screen.size | async].join(' ')
    "
    (ngSubmit)="search()"
  >
    <un-input
      class="country"
      type="auto-complete"
      formControlName="citizenship"
      [autoComplete]="countryService.autoComplete"
      placeholder="Citizenship"
      i18n-placeholder
    ></un-input>
    <un-input
      class="country"
      type="auto-complete"
      formControlName="country"
      [autoComplete]="countryService.autoComplete"
      placeholder="Destination"
      i18n-placeholder
    ></un-input>
    <un-button class="btn" type="primary" i18n="@@search" (click)="search()"
      >Search</un-button
    >
  </div>
  }
</div>
